import * as React from "react";
import { createRoot } from 'react-dom/client';
import 'react-app-polyfill/ie11'; // React Polyfills for IE11

import App from "./components/App";

declare const variationId: string;

/*
 * Polyfill for includes() method in String
 * for IE11 and older browsers.
 */
if (!String.prototype.includes) {
    String.prototype.includes = function () {
        'use strict';
        return String.prototype.indexOf.apply(this, arguments) !== -1;
    };
}

const autoWizard = document.getElementById("AutoWizard");
const root = createRoot(autoWizard!); // createRoot(container!) if you use TypeScript

if (autoWizard != null) {
    root.render(<App variation={variationId} />);
}